/**
 * v2 Theme - Shadows
 */
const shadows = {
  card: "0 6px 20px rgba(0,0,0,0.30)",
  soft: "0 2px 10px rgba(0,0,0,0.30)",
  insetSoft: "inset 0 1px 0 rgba(255,255,255,0.04)",
};

export default shadows;

